import { all, call, put, takeEvery } from 'redux-saga/effects'
import { globalLoaderText } from "redux/CommonDashboard/actions";
import AssetInventoryAPiService from './AssetInventoryAPiService';
import { setAllUsers, setUserCreationSuccess, setUserById, setModulesList, setUserModules, setPreviousYearResultData, setUsersAssessmentsExcelData, setUserAttemptsById, setUsersCostCenterFilterList, setUsersHomeCostCenterFilterList, setUsersLatestScoreFilterList, setUsersByCostCenter, setSaveUserByCostCenter, setUserCostCentersDropDownList, setUserCostCenterModulesList, setSaveUserCostCenterModules } from 'Store/AssetInventory/Users/UsersAction';
import { GET_ALL_USERS, GET_USER_BY_ID, CREATE_USER, GET_MODULES_LIST, GET_USER_MODULES, DOWNLOAD_PREVIOUS_YEAR_RESULTS, EXPORT_USERS_ASSESSMENTS, GET_USER_ATTEMPTS_BY_ID, GET_USERS_COST_CENTERS_FILTER_LIST, GET_USERS_HOME_COST_CENTERS_FILTER_LIST, GET_USERS_LATEST_SCORE_FILTER_LIST, GET_USERS_BY_COST_CENTER, GET_SAVE_USER_BY_COST_CENTER, GET_USER_COST_CENTERS, GET_USER_COST_CENTERS_MODULES_LIST, GET_SAVE_USER_COST_CENTERS_MODULES } from 'Store/AssetInventory/Users/UsersTypes';
import { API_URL, apiMethod, apiType } from 'utils';
import { IPayload } from 'Model/IPayload';

function* createUser(user: any): any {
    try {
        yield put(globalLoaderText("Saving User...."));
        let payloadData : IPayload = {
            apiType : apiType.AssetManagement,
            endpoint : `inventoryadmin/saveusermodule`,
            apiMethod :  apiMethod.POST,
            payload : user.user
        }
        const response = yield call(
            AssetInventoryAPiService.post,
            API_URL.PostWebApp, payloadData
        );

        if (response) {
            yield put(globalLoaderText(""));
            yield put(setUserCreationSuccess("success"))
        }
        else {
            yield put(setUserCreationSuccess("failed"))
            yield put(globalLoaderText(""));
        }
    } catch (error) {
        console.log(error);
        yield put(globalLoaderText(""));
        yield put(setUserCreationSuccess("failed"))
    }
}

function* getAllUsers(req: any): any {
    try {
        yield put(globalLoaderText("Fetching Users...."));
        let payloadData : IPayload = {
            apiType : apiType.AssetManagement,
            endpoint : `inventoryadmin/grid/userassessmentstatus`,
            apiMethod :  apiMethod.POST,
            payload : req?.payload
        }
        const response = yield call(
            AssetInventoryAPiService.post,
            API_URL.PostWebApp, payloadData
            );

        if (response) {
            yield put(globalLoaderText(""));
            yield put(setAllUsers(response))
        } else {
            yield put(setAllUsers([]))
            yield put(globalLoaderText(""));
        }
    } catch (error) {
        console.log(error);
        yield put(globalLoaderText(""));
    }
}

function* getModulesList(): any {
    try {
        yield put(globalLoaderText("Fetching Modules...."));
        let payloadData : IPayload = {
            apiType : apiType.AssetManagement,
            endpoint : `inventoryadmin/dropdown/assessment/getmodule`,
            apiMethod :  apiMethod.GET,
            payload : null
        }
        const response = yield call(
            AssetInventoryAPiService.post,
            API_URL.PostWebApp, payloadData
            );

        if (response) {
            yield put(globalLoaderText(""));
            yield put(setModulesList(response))
        } else {
            yield put(setModulesList([]))
            yield put(globalLoaderText(""));
        }
    } catch (error) {
        console.log(error);
        yield put(globalLoaderText(""));
    }
}



function* getUserById(data: any): any {
    try {
        yield put(globalLoaderText("Fetching User...."));
        let payloadData : IPayload = {
            apiType : apiType.AssetManagement,
            endpoint : `inventoryadmin/userdetailsforassessment?userEmailId=${data.id}&costCenter=${data.costCenter}`,
            apiMethod :  apiMethod.GET,
            payload : null
        }
        const response = yield call(
            AssetInventoryAPiService.post,
            API_URL.PostWebApp, payloadData
            );

        if (response) {
            yield put(globalLoaderText(""));
            yield put(setUserById(response))
        } else {
            yield put(setUserById({}))
            yield put(globalLoaderText(""));
        }
    } catch (error) {
        console.log(error);
        yield put(setUserById({
            error: "Not able to find the details"
        }))
        yield put(globalLoaderText(""));
    }
}

function* getUserModules(data: any): any {
    try {
        yield put(globalLoaderText("Fetching User...."));
        let payloadData : IPayload = {
            apiType : apiType.AssetManagement,
            endpoint : `inventoryadmin/usermodulassociation?userEmailId=${data.emailId}`,
            apiMethod :  apiMethod.GET,
            payload : null
        }
        const response = yield call(
            AssetInventoryAPiService.post,
            API_URL.PostWebApp, payloadData
            );

        if (response) {
            yield put(globalLoaderText(""));
            yield put(setUserModules(response))
        } else {
            yield put(setUserModules([]))
            yield put(globalLoaderText(""));
        }
    } catch (error) {
        console.log(error);
        yield put(globalLoaderText(""));
    }
}

function* downloadPreviousYearResults(): any {
    try {
        yield put(globalLoaderText("Fetching Results...."));
        let payloadData : IPayload = {
            apiType : apiType.AssetManagement,
            endpoint : `inventory/archive/assessment/export`,
            apiMethod :  apiMethod.POST,
            payload : null
        }
        const response = yield call(
            AssetInventoryAPiService.post,
            API_URL.PostWebApp, payloadData
            );

        if (response) {
            yield put(setPreviousYearResultData(response))
        } else {
            yield put(setPreviousYearResultData('No Data Found'))
        }
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setPreviousYearResultData('No Data Found'))
        yield put(globalLoaderText(""));
    }
}

function* exportUsersAssessments(req: any): any {
    try {
        yield put(globalLoaderText("Fetching Data...."));
        let payloadData : IPayload = {
            apiType : apiType.AssetManagement,
            endpoint : `inventoryadmin/userassessmentstatus/excel`,
            apiMethod :  apiMethod.POST,
            payload : req?.payload
        }
        const response = yield call(
            AssetInventoryAPiService.post,
            API_URL.PostWebApp, payloadData
            );

        if (response) {
            yield put(setUsersAssessmentsExcelData(response))
        } else {
            yield put(setUsersAssessmentsExcelData('No Data Found'))
        }
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setUsersAssessmentsExcelData('No Data Found'))
        yield put(globalLoaderText(""));
    }
}

function* getUserAttemptsById(req: any): any {
    try {
        yield put(globalLoaderText("Fetching Attempts...."));
        let payloadData : IPayload = {
            apiType : apiType.AssetManagement,
            endpoint : `inventoryadmin/userassessmentresult/${req?.payload}`,
            apiMethod :  apiMethod.GET,
            payload : null
        }
        const response = yield call(
            AssetInventoryAPiService.post,
            API_URL.PostWebApp, payloadData
            );

        if (response) {
            yield put(setUserAttemptsById(response))
        } else {
            yield put(setUserAttemptsById([]))
        }
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setUserAttemptsById([]))
        yield put(globalLoaderText(""));
    }
}

function* getCostCentersFilters(): any {
    try {
        yield put(globalLoaderText("Fetching options...."));
        let payloadData : IPayload = {
            apiType : apiType.AssetManagement,
            endpoint : `asssetinventory/dropdown/costcenter`,
            apiMethod :  apiMethod.GET,
            payload : null
        }
        const response = yield call(
            AssetInventoryAPiService.post,
            API_URL.PostWebApp, payloadData
            );

        if (response) {
            yield put(setUsersCostCenterFilterList(response))
        } else {
            yield put(setUsersCostCenterFilterList([]))
        }
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setUsersCostCenterFilterList([]))
        yield put(globalLoaderText(""));
    }
}

function* getHomeCostCentersFilters(): any {
    try {
        yield put(globalLoaderText("Fetching options...."));
        let payloadData : IPayload = {
            apiType : apiType.AssetManagement,
            endpoint : `asssetinventory/dropdown/homecostcenter`,
            apiMethod :  apiMethod.GET,
            payload : null
        }
        const response = yield call(
            AssetInventoryAPiService.post,
            API_URL.PostWebApp, payloadData
            );

        if (response) {
            yield put(setUsersHomeCostCenterFilterList(response))
        } else {
            yield put(setUsersHomeCostCenterFilterList([]))
        }
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setUsersHomeCostCenterFilterList([]))
        yield put(globalLoaderText(""));
    }
}

function* getLatestScoreFilters(): any {
    try {
        yield put(globalLoaderText("Fetching options...."));
        let payloadData : IPayload = {
            apiType : apiType.AssetManagement,
            endpoint : `asssetinventory/dropdown/latestscore`,
            apiMethod :  apiMethod.GET,
            payload : null
        }
        const response = yield call(
            AssetInventoryAPiService.post,
            API_URL.PostWebApp, payloadData
            );

        if (response) {
            yield put(setUsersLatestScoreFilterList(response))
        } else {
            yield put(setUsersLatestScoreFilterList([]))
        }
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setUsersLatestScoreFilterList([]))
        yield put(globalLoaderText(""));
    }
}

function* getAllUsersbyCostCenterSaga(req?: any): any {
    try {
        yield put(globalLoaderText("Fetching User Grid Data...."));
        let payloadData: IPayload = {
            apiType: apiType.AssetManagement,
            endpoint: `asssetinventory/users`,
            apiMethod: apiMethod.POST,
            payload: req?.payload
        }
        const response = yield call(
            AssetInventoryAPiService.post,
            API_URL.PostWebApp, payloadData
        );

        if (response) {
            yield put(globalLoaderText(""));
            yield put(setUsersByCostCenter(response))
        } else {
            yield put(setUsersByCostCenter([]))
            yield put(globalLoaderText(""));
        }
    } catch (error) {
        yield put(globalLoaderText(""));
        yield put(setUsersByCostCenter([]))
    }
}

function* saveUsersbyCostCenterSaga(req?: any): any {
    try {
        yield put(globalLoaderText("Saving Users...."));
        let payloadData: IPayload = {
            apiType: apiType.AssetManagement,
            endpoint: `asssetinventory/users/modules`,
            apiMethod: apiMethod.POST,
            payload: req?.payload
        }
        const response = yield call(
            AssetInventoryAPiService.post,
            API_URL.PostWebApp, payloadData
        );

        yield put(globalLoaderText(""));
        yield put(setSaveUserByCostCenter(response))

    } catch (error) {
        yield put(globalLoaderText(""));
        yield put(setSaveUserByCostCenter(false))
    }
}

function* getUserCostCentersDropdownList(req:any): any {
    try {
        yield put(globalLoaderText("Fetching User CostCenters...."));
        let payloadData : IPayload = {
            apiType : apiType.AssetManagement,
            endpoint : `asssetinventory/dropdown/costcenter/${req?.userId}/${req?.loggedUserId}`,
            apiMethod :  apiMethod.GET,
            payload : null
        }
        const response = yield call(
            AssetInventoryAPiService.post,
            API_URL.PostWebApp, payloadData
            );

        if (response) {
            yield put(setUserCostCentersDropDownList(response))
        } else {
            yield put(setUserCostCentersDropDownList([]))
        }
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setUserCostCentersDropDownList([]))
        yield put(globalLoaderText(""));
    }
}

function* getUserCostCentersModulesListSaga(req?: any): any {
    try {
        yield put(globalLoaderText("Fetching User Cost Centers Modules Grid Data...."));
        let payloadData: IPayload = {
            apiType: apiType.AssetManagement,
            endpoint: `asssetinventory/costcenters`,
            apiMethod: apiMethod.POST,
            payload: req?.payload
        }
        const response = yield call(
            AssetInventoryAPiService.post,
            API_URL.PostWebApp, payloadData
        );

        if (response) {
            yield put(globalLoaderText(""));
            yield put(setUserCostCenterModulesList(response))
        } else {
            yield put(setUserCostCenterModulesList([]))
            yield put(globalLoaderText(""));
        }
    } catch (error) {
        yield put(globalLoaderText(""));
        yield put(setUserCostCenterModulesList([]))
    }
}

function* getSaveUserCostCentersModulesSaga(req?: any): any {
    try {
        yield put(globalLoaderText("Saving User CostCenter Modules...."));
        let payloadData: IPayload = {
            apiType: apiType.AssetManagement,
            endpoint: `asssetinventory/costcenter/modules`,
            apiMethod: apiMethod.POST,
            payload: req?.payload
        }
        const response = yield call(
            AssetInventoryAPiService.post,
            API_URL.PostWebApp, payloadData
        );

        if (response) {
            yield put(globalLoaderText(""));
            yield put(setSaveUserCostCenterModules(response))
        } else {
            yield put(setSaveUserCostCenterModules(false))
            yield put(globalLoaderText(""));
        }
    } catch (error) {
        yield put(setSaveUserCostCenterModules(false));
        yield put(setUserCostCenterModulesList([]))
        yield put(globalLoaderText(""));
    }
}

function* watchUsers() {
    yield takeEvery(GET_ALL_USERS, getAllUsers)
    yield takeEvery(GET_USER_BY_ID, getUserById)
    yield takeEvery(CREATE_USER, createUser)
    yield takeEvery(GET_MODULES_LIST, getModulesList)
    yield takeEvery(GET_USER_MODULES, getUserModules)
    yield takeEvery(DOWNLOAD_PREVIOUS_YEAR_RESULTS, downloadPreviousYearResults)
    yield takeEvery(EXPORT_USERS_ASSESSMENTS, exportUsersAssessments)
    yield takeEvery(GET_USER_ATTEMPTS_BY_ID, getUserAttemptsById)
    yield takeEvery(GET_USERS_COST_CENTERS_FILTER_LIST, getCostCentersFilters)
    yield takeEvery(GET_USERS_HOME_COST_CENTERS_FILTER_LIST, getHomeCostCentersFilters)
    yield takeEvery(GET_USERS_LATEST_SCORE_FILTER_LIST, getLatestScoreFilters)

    yield takeEvery(GET_USERS_BY_COST_CENTER, getAllUsersbyCostCenterSaga)
    yield takeEvery(GET_SAVE_USER_BY_COST_CENTER, saveUsersbyCostCenterSaga)
    yield takeEvery(GET_USER_COST_CENTERS,getUserCostCentersDropdownList)
    yield takeEvery(GET_USER_COST_CENTERS_MODULES_LIST,getUserCostCentersModulesListSaga)
    yield takeEvery(GET_SAVE_USER_COST_CENTERS_MODULES,getSaveUserCostCentersModulesSaga)
}

export default function* combinedSaga() {
    yield all([
        watchUsers()
    ])
}